import * as React from 'react'
import autobind from 'autobind-decorator'
import { RadioGroup, FormControlLabel, Radio } from '@material-ui/core'
import { compose } from 'redux'
import Alert from 'src/shared/Alert/Alert'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import Chart from 'src/shared/Cotation/chart/Chart'

interface IProps extends WithI18n{
  data: any;
  withDescribe?: boolean;
  isDefault?: boolean;
}

interface IState{
    payoff: string
}

class ChartContext extends React.Component<IProps, IState> {
    state = {
        payoff: "0"
    }

    render() {
        const {data, withDescribe, isDefault, t} = this.props;
        return (
            <>
                {data &&
                    <>
                        <RadioGroup
                            name="payoff"
                            value={this.state.payoff}
                            onChange={this.handleChangePayoff}
                        >
                            {data.map((d, i) => (
                                <FormControlLabel 
                                    key={`option-${i}`} 
                                    value={d.option} 
                                    control={<Radio />} 
                                    label={d.label} />
                            ))}
                        </RadioGroup>
                        <br />
                        <div>
                            <Chart 
                                data={isDefault ? this.optionChartRender('chartDefault') : this.optionChartRender('chart')} 
                                config={this.optionChartRender('config')}
                                legend={this.optionChartRender('legends')}
                                condition={isDefault ? true : this.optionChartRender('condition')}
                                {...{isDefault}}
                            />
                        </div>
                        {withDescribe && (isDefault ? true : this.optionChartRender('condition')) &&
                            <div>
                                {isDefault && this.optionChartRender('describe') &&
                                    <Alert type="warning">{t.Cotation_chart_warning}</Alert>
                                }
                                <br />
                                {this.optionChartRender('describe') &&
                                    <Alert type="info">
                                        {this.optionChartRender('describe')}
                                    </Alert>
                                }
                            </div>
                        }
                    </>
                }
                {!data &&
                    <Alert type="info">Pas de graphique disponible pour ce scénario</Alert>
                }
            </>
        )
    }

    componentDidMount(){
        if(this.props.data){
            this.setState({payoff: this.props.data[0].option})
        }
    }

    componentDidUpdate(prevPros){
        const {data} = this.props
        if(prevPros.data !== data && data){
            this.setState({payoff: data[0].option})
        }
    }

    handleChangePayoff = event => {
        this.setState({payoff: event.target.value});
    }

    @autobind
    private optionChartRender(option: string){
        const {data} = this.props
        const findResult = data ? data.find(d => d.option === this.state.payoff) :undefined
        return findResult ? findResult[option] : undefined
    }
}

export default compose(
  withI18n
)(ChartContext)



// WEBPACK FOOTER //
// ./src/shared/Cotation/chart/ChartContext.tsx